import type {
  PresetKey,
  TimeFilter,
} from "@/components/v2/DatePicker/constants";

import { createContext } from "react";
import type { DateRange } from "react-day-picker";

export type IContaminationPageContext = {
  dateRange?: DateRange;
  datePreset?: PresetKey;
  timeFilter?: TimeFilter;
  comparisonTimeFilter?: TimeFilter;
  selectedTenantCategoryIds: string[] | null;
};

export const ContaminationPageContext = createContext({
  dateRange: undefined,
  datePreset: undefined,
  timeFilter: undefined,
  comparisonTimeFilter: undefined,
  selectedTenantCategoryIds: null,
} as IContaminationPageContext);
